import {withParams} from 'vuelidate'

export default (occurrencesToCheckFunction, matchingOccurrencesFunction, displayableMatchesFunction) => withParams(
  {
    type: 'noDuplicateOccurrences',
    matches: displayableMatchesFunction}, function (value)
  {






      //TODO: restore me
   // return true
    let ret =  occurrencesToCheckFunction(value).length === matchingOccurrencesFunction(value).length

    // console.log(value, ret)
    // if (ret !== true) {
    //   console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!3')
    //   console.log('noDuplicateOccurrences: ', value)
    //   console.log('noDuplicateOccurrences: - occurrencesToCheckFunction', occurrencesToCheckFunction(value).length)
    //   console.log('noDuplicateOccurrences: - matchingOccurrencesFunction', matchingOccurrencesFunction(value).length)
    //   console.log('noDuplicateOccurrences: - displayableMatchesFunction', displayableMatchesFunction(value))
    //   console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!3', value, ret)
    // }
    return ret
  }
)



// WEBPACK FOOTER //
// ./src/validators/noDuplicateOccurrences.js